import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const LandingPageFooter = () => {
       const { t } = useTranslation();

    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
        },
        {
          threshold: 0.2,
        },
      );
      const footer = document.querySelector("footer");
      if (footer) {
        observer.observe(footer);
      }
      return () => {
        if (footer) {
          observer.unobserve(footer);
        }
      };
    }, []);
  return (
    <>
      <style>
        {`
          .landingPageFooter {
            background-color: #ffffff;
            min-height: 100vh;
            display: grid;
            place-items: center;
            position: relative;
            overflow: hidden;
          }

          .footer-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 6rem;
            max-width: 1200px;
            width: 90%;
            position: relative;
            margin-left: 2rem;
          }

          @media screen and (min-width: 1024px){
          .footer-grid {
          margin-left: 5rem;
          }
          }
          .footer-left {
            display: flex;
            flex-direction: column;
            gap: 2rem;
            padding: 4rem 0;
          }
          .footer-right {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            padding: 4rem 0;
          }
          .footer-cta {
            font-size: 3.5rem;
            font-weight: 300;
            color: #111827;
            line-height: 1.2;
            opacity: 0;
            transform: translateX(-20px);
            transition: opacity 1s ease, transform 1s ease;
          }
          .visible .footer-cta {
            opacity: 1;
            transform: translateX(0);
          }
          .footer-cta span {
            display: block;
            font-weight: 600;
          }
          .contact-info {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 1s ease 0.4s, transform 1s ease 0.4s;
          }
          .visible .contact-info {
            opacity: 1;
            transform: translateY(0);
          }
          .contact-item {
            font-size: 1.1rem;
            color: #6b7280;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
            width: fit-content;
          }
          .contact-item:hover {
            color: #111827;
            transform: translateX(10px);
          }
          .contact-item::before {
            content: '';
            position: absolute;
            left: -20px;
            top: 50%;
            width: 0;
            height: 1px;
            background: #111827;
            transition: width 0.3s ease;
          }
          .contact-item:hover::before {
            width: 15px;
          }
          .policy-links {
          font-size: smaller !important;
            display: flex;
            flex-direction: row;
            gap: 2rem;
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 1s ease 0.6s, transform 1s ease 0.6s;
          }
            @media screen and (max-width: 700px){
            .policy-links {
            flex-direction: column;
            }
              
            }
          .visible .policy-links {
            opacity: 1;
            transform: translateY(0);
          }
          .policy-links a {
            color: #9ca3af;
            text-decoration: none;
          
            transition: all 0.3s ease;
            position: relative;
            padding-bottom: 2px;
          }
          .policy-links a::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 1px;
            background-color: #111827;
            transition: width 0.3s ease;
          }
          .policy-links a:hover {
            color: #111827;
          }
          .policy-links a:hover::after {
            width: 100%;
          }
          @media (max-width: 768px) {
            .footer-grid {
              grid-template-columns: 1fr;
              gap: 3rem;
            }
            .footer-cta {
              font-size: 2.5rem;
            }
            .footer-right {
              justify-content: flex-start;
            }
          }
           
        `}
      </style>
      <footer className={isVisible ? "visible" : ""}>
        <div className="footer-grid">
          <div className="footer-left">
            <h2 className="footer-cta">
              {t('ready')}
              <span>{t('vision')}</span>
            </h2>
            <div className="contact-info">
              <div className="contact-item">info@archicode.nl</div>
              <div className="contact-item">Onderwijsboulevard 464, 's-Hertogenbosch</div>
            </div>
          </div>
          <div className="footer-right">
            <div className="policy-links">
              <a href="/privacy">Terms and Conditions</a>
              <a href="/cookies">Cookie Policy</a>
              <span>KVK: 96987227</span>
              <span>Btw-id: NL005241873B39</span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default LandingPageFooter;
